var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "modify-order-no-box" },
    [
      _c(
        "el-form",
        {
          ref: "ruleModifyOrderNoForm",
          staticClass: "modify-order-no",
          attrs: {
            model: _vm.ruleModifyOrderNoForm,
            rules: _vm.ruleModifyOrderNo,
          },
        },
        [
          _vm.type !== "modifyOrderNoOneTui" && _vm.orderObj.splitType == 0
            ? _c(
                "el-form-item",
                { attrs: { label: "出库仓库" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        filterable: "",
                        clearable: "",
                        placeholder: "请选择出库仓库（选填）",
                      },
                      model: {
                        value: _vm.ruleModifyOrderNoForm.commWarehouseId,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.ruleModifyOrderNoForm,
                            "commWarehouseId",
                            $$v
                          )
                        },
                        expression: "ruleModifyOrderNoForm.commWarehouseId",
                      },
                    },
                    _vm._l(_vm.commWarehouseList, function (item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            { attrs: { label: "物流公司", prop: "logisticsCompany" } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    filterable: "",
                    clearable: "",
                    placeholder: "请选择物流公司",
                  },
                  model: {
                    value: _vm.ruleModifyOrderNoForm.logisticsCompany,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.ruleModifyOrderNoForm,
                        "logisticsCompany",
                        $$v
                      )
                    },
                    expression: "ruleModifyOrderNoForm.logisticsCompany",
                  },
                },
                _vm._l(
                  _vm.dictionaries.courier_company,
                  function (item, index) {
                    return _c("el-option", {
                      key: index,
                      attrs: { label: item.dictName, value: item.dictId },
                    })
                  }
                ),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "物流单号", prop: "logisticsNumber" } },
            [
              _c("el-input", {
                attrs: {
                  oninput: "value=value.replace(/[^\\w]/g,'')",
                  placeholder: "请填写物流单号",
                },
                model: {
                  value: _vm.ruleModifyOrderNoForm.logisticsNumber,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.ruleModifyOrderNoForm,
                      "logisticsNumber",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "ruleModifyOrderNoForm.logisticsNumber",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }